import { render, staticRenderFns } from "./minors.vue?vue&type=template&id=19fa6698&scoped=true&"
import script from "./minors.vue?vue&type=script&lang=js&"
export * from "./minors.vue?vue&type=script&lang=js&"
import style0 from "./minors.vue?vue&type=style&index=0&id=19fa6698&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fa6698",
  null
  
)

export default component.exports